// Centralised API base URL.
// - On production (homego-removals.com + www variant), use same-origin ('') so fetches go to
//   `/api/...` relative paths. This avoids ANY cross-origin CORS issues permanently.
// - On dev/preview, use the REACT_APP_BACKEND_URL env var (preview backend URL).
const SAME_ORIGIN_HOSTS = new Set(['homego-removals.com', 'www.homego-removals.com']);

function resolveApiBase() {
  if (typeof window !== 'undefined' && SAME_ORIGIN_HOSTS.has(window.location.hostname)) {
    return ''; // relative — same-origin fetch
  }
  return process.env.REACT_APP_BACKEND_URL || '';
}

export const API_BASE = resolveApiBase();
export default API_BASE;

// Convenience helpers used by feature components
export async function apiGet(path) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'GET',
    headers: { 'Accept': 'application/json' },
  });
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function apiPost(path, body, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    body: body == null ? null : JSON.stringify(body),
  });
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}
